import { render, staticRenderFns } from "./CatalogosArticulos.vue?vue&type=template&id=14854553&"
import script from "./CatalogosArticulos.vue?vue&type=script&lang=js&"
export * from "./CatalogosArticulos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports